import { defineStore } from 'pinia';

import { PiniaStoreId } from '@/constants/pinia';

import { setupInventoryActions } from './inventory.actions';
import { setupInventoryState } from './inventory.state';

export const useInventoryStore = defineStore(PiniaStoreId.Inventory, () => {
  const state = setupInventoryState();
  const actions = setupInventoryActions(state);

  return {
    ...actions,
    ...state,
  };
});
